import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'
import {
  AI_RISK_REPORT_RENDER_MODE_VALUES,
  DEFAULT_AI_RISK_REPORT_RENDER_MODE,
  isAiRiskReportExportMode,
} from '../../data/renderMode'
import {
  AI_RISK_REPORT_CHANNELS,
  AI_RISK_REPORT_CHANNEL_VALUES,
  DEFAULT_AI_RISK_REPORT_CHANNEL,
} from '../../data/reportChannel'

const AIRiskReportRenderModeContext = createContext(DEFAULT_AI_RISK_REPORT_RENDER_MODE)
const AIRiskReportChannelContext = createContext(DEFAULT_AI_RISK_REPORT_CHANNEL)

export function AIRiskReportRenderModeProvider({
  renderMode = DEFAULT_AI_RISK_REPORT_RENDER_MODE,
  channel = DEFAULT_AI_RISK_REPORT_CHANNEL,
  children,
}) {
  return (
    <AIRiskReportChannelContext.Provider value={channel}>
      <AIRiskReportRenderModeContext.Provider value={renderMode}>{children}</AIRiskReportRenderModeContext.Provider>
    </AIRiskReportChannelContext.Provider>
  )
}

AIRiskReportRenderModeProvider.propTypes = {
  renderMode: PropTypes.oneOf(AI_RISK_REPORT_RENDER_MODE_VALUES),
  channel: PropTypes.oneOf(AI_RISK_REPORT_CHANNEL_VALUES),
  children: PropTypes.node.isRequired,
}

export const useAIRiskReportRenderMode = () => useContext(AIRiskReportRenderModeContext)
export const useAIRiskReportChannel = () => useContext(AIRiskReportChannelContext)

export const useAIRiskReportExportMode = () => isAiRiskReportExportMode(useAIRiskReportRenderMode())

export const useAIRiskReportGaBrowserMode = () => {
  const channel = useAIRiskReportChannel()
  const isExportMode = useAIRiskReportExportMode()

  return channel === AI_RISK_REPORT_CHANNELS.GA && !isExportMode
}
